import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { CustomSelect } from '../common/formFields/customSelect';
import { DayPicker } from 'react-day-picker'; 
import 'react-day-picker/dist/style.css';

import { redirectTo, createQs, hasPermission } from '../../store/apiWrapper';
import { appContextActions } from '../../store/appContextStore';
import { customParseDate } from '../common/customParseDate';
import { hasRatingTypePermission } from '../common/ratingTypePermission'
import FieldHorizontal from '../common/formFields/fieldHorizontal'
import InputControl from '../common/formFields/inputControl';

const ratingTypes = ["smecz", "corpcz", "smesk", "nonProfitOrganizationcz", "entrepreneurcz", "housingCooperativecz", "municipalitycz", "municipalitysk"]
const formatDate = (date) => (date ? moment(date).format('L') : "");
const isEmptySelectValue = (value) => value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0);

class HistorySearchComponent extends React.Component {
    constructor(props) {
        super(props);
        const filterDateFrom = this.getDateFrom();
        const filterDateTo = new Date();
        this.state = {
            ico: "", filterDateFrom, filterDateTo, filterDateFromText: formatDate(filterDateFrom), filterDateToText: formatDate(filterDateTo),
            filterDateFromError: null, filterDateToError: null,
            name: "", ratingType: ["all"], ratingFrom: null, ratingTo: null,
            ratingTypes: this.getRatingTypes(), customerId: null, showFromCalendar: false, showToCalendar: false
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.updateRatingsValues(this.state.ratingType);
        if (!this.props.ratingRange.isLoading && !hasPermission(null, "UserRatingMSP") && this.props.ratingRange.ratingRange.length > 0 && (this.props.ratingRange.rating[0] === this.state.ratingType[0] && (isEmptySelectValue(this.state.ratingTo) || isEmptySelectValue(this.state.ratingFrom)))) {
            this.setState({
                ratingFrom: this.props.ratingRange.ratingRange[0],
                ratingTo: this.props.ratingRange.ratingRange[this.props.ratingRange.ratingRange.length - 1]
            });
        }
        if (!this.props.domainsHistory.isLoading && hasPermission(null, "UserCCB"))
            this.props.loadDomainHistory();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    getDateFrom = () => {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        return customParseDate(formatDate(new Date(y, m - 1, 1)), "L", moment.locale());
    }

    getRatingTypes = () => {
        let types = ["all"]
        ratingTypes.forEach(element => {
            if (hasRatingTypePermission(element)) {
                types.push(element);
            }
        });
        return types;
    }

    componentDidUpdate(){
        if (!this.props.ratingRange.isLoading && !hasPermission(null, "UserRatingMSP") && this.props.ratingRange.ratingRange.length > 0 && (this.props.ratingRange.rating[0] === this.state.ratingType[0] && (isEmptySelectValue(this.state.ratingTo) || isEmptySelectValue(this.state.ratingFrom)))) {
            this.setState({
                ratingFrom: this.props.ratingRange.ratingRange[0],
                ratingTo: this.props.ratingRange.ratingRange[this.props.ratingRange.ratingRange.length - 1]
            });
        }
        if (!this.props.domainsHistory.isLoading && hasPermission(null, "UserCCB"))
            this.props.loadDomainHistory();
    }

    updateRatingsValues = (code) => {
        if (!hasPermission(null, "UserRatingMSP")) {
            this.props.loadRatingRange(code);
        }
    }

    handleSearchSubmit = (event) => {
        event.preventDefault();
        if (hasPermission(null, "UserCCB")) {
            redirectTo(`/history/result?${createQs({ name: this.state.name, ico: this.state.ico, ratingType: this.state.ratingType, ratingFrom: this.state.ratingFrom, ratingTo: this.state.ratingTo, filterDateFrom: moment(this.state.filterDateFrom).toISOString(), filterDateTo: moment(this.state.filterDateTo).toISOString(), customerId: this.state.customerId })}`);
        }
        else if (hasPermission(null, "UserRatingCalc") || hasPermission(null, "PartnerView")) {
            redirectTo(`/history/result?${createQs({ name: this.state.name, ico: this.state.ico, ratingType: this.state.ratingType, ratingFrom: this.state.ratingFrom, ratingTo: this.state.ratingTo, filterDateFrom: moment(this.state.filterDateFrom).toISOString(), filterDateTo: moment(this.state.filterDateTo).toISOString() })}`);
        }
        else if (hasPermission(null, "UserRatingMSP")) {
            redirectTo(`/history/result?${createQs({ name: this.state.name, ico: this.state.ico, ratingType: this.state.ratingType, filterDateFrom: moment(this.state.filterDateFrom).toISOString(), filterDateTo: moment(this.state.filterDateTo).toISOString() })}`);
        }
        else {
            redirectTo(`/history/result?${createQs({ ratingFrom: this.state.ratingFrom, ratingTo: this.state.ratingTo, filterDateFrom: moment(this.state.filterDateFrom).toISOString(), filterDateTo: moment(this.state.filterDateTo).toISOString() })}`);
        }

    }

    handleClickOutside = (event) => {
        if (this.state.showFromCalendar || this.state.showToCalendar) {
            if (!event.target.closest('.control')) {
                this.setState({ 
                    showFromCalendar: false, 
                    showToCalendar: false 
                });
            }
        }
    }

    changeEvent = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    tryCommitDate = (field) => {
        const textField = `${field}Text`;
        const errorField = `${field}Error`;
        const rawValue = (this.state[textField] || "").trim();

        if (rawValue.length === 0) {
            this.setState({ [errorField]: this.props.t('Common.RequiredField') });
            return;
        }

        const parsedDate = customParseDate(rawValue, "L", moment.locale());
        if (!parsedDate) {
            this.setState({ [errorField]: this.props.t('IRating.History.InvalidDate') || this.props.t('Common.InvalidDate') || 'Invalid date' });
            return;
        }

        this.setState({
            [field]: parsedDate,
            [textField]: formatDate(parsedDate),
            [errorField]: null
        });
    }

    handleDateTextChange = (field, value) => {
        const textField = `${field}Text`;
        const errorField = `${field}Error`;
        this.setState({ [textField]: value, [errorField]: null });
    }

    handleDateTextKeyDown = (event, field) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.tryCommitDate(field);
        }
    }

    render() {
        return (
            <div className="columns work-container">
                <div className="column left-navbar-container">
                </div>
                <div className="column right-body-container is-three-quarters">
                    <div className="container is-centered columns">
                        {this.renderSearch()}
                    </div>
                </div>
                <div className="column">
                </div>
            </div>
        )
    }

    renderSearch() {
        return (
            <div className="column is-6 form-layout">
                <div className="box">
                    <div className="has-text-centered">
                        <h1 className="title is-4">{this.props.t('IRating.History.Search.Title')}</h1>
                    </div>
                    <form onSubmit={(e) => this.handleSearchSubmit(e)}>
                        <div className="container">
                            {(hasPermission(null, "UserRatingMSP") || hasPermission(null, "UserCCB") || hasPermission(null, "UserRatingCalc") || hasPermission(null, "PartnerView")) &&
                            <>
                            <FieldHorizontal label={this.props.t('IRating.History.RatingType')}>
                                <CustomSelect
                                    value={this.state.ratingType[0]}
                                    onChange={ratingType => { const ratingTypes = ratingType ? [ratingType] : []; this.setState({ ratingType: ratingTypes, ratingFrom: null, ratingTo: null }); this.updateRatingsValues(ratingTypes); }}
                                    options={this.state.ratingTypes.map(x => { return { value: x, label: this.props.t(`IRating.Report.${x.toLowerCase()}`) } })}
                                    isMulti={false}
                                    isLoading={this.props.ratingRange.isLoading}
                                    placeholder={this.props.t(`Common.Select`)}
                                />
                            </FieldHorizontal>
                            <FieldHorizontal label={this.props.t('IRating.Report.Search.Ico')}>
                                <InputControl type="text" fieldName="ico" value={this.state.ico} placeholder={this.props.t('IRating.Report.Search.Ico')} onChange={this.changeEvent}/>
                            </FieldHorizontal>
                            <FieldHorizontal label={this.props.t('IRating.Report.Search.Name')}>
                            <InputControl type="text" fieldName="name" value={this.state.name} placeholder={this.props.t('IRating.Report.Search.Name')} onChange={this.changeEvent}/>
                            </FieldHorizontal>
                            </>
                            }
                            {!hasPermission(null, "UserRatingMSP") &&
                                <div className="field is-horizontal">
                                    <div className="field-label" style={{ whiteSpace: "nowrap" }}><label className="label">
                                        {this.props.t('IRating.History.Rating')}</label>
                                    </div>
                                    <div className="field-body">
                                        <div className="field-label">
                                            {this.props.t('IRating.History.From')}
                                        </div>
                                        <div className="field-body">
                                            <div className="field">
                                                <div className="control">
                                                    <CustomSelect
                                                        value={this.state.ratingFrom}
                                                        onChange={ratingFrom => this.setState({ ratingFrom })}
                                                        options={this.props.ratingRange.ratingRange.map(x => { return { value: x, label: x } })}
                                                        isMulti={false}
                                                        isLoading={this.props.ratingRange.isLoading}
                                                        placeholder={this.props.t(`Common.Select`)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field-label">
                                            {this.props.t('IRating.History.To')}
                                        </div>
                                        <div className="field-body">
                                            <div className="field">
                                                <div className="control">
                                                    <CustomSelect
                                                        value={this.state.ratingTo}
                                                        onChange={ratingTo => this.setState({ ratingTo })}
                                                        options={this.props.ratingRange.ratingRange.map(x => { return { value: x, label: x } })}
                                                        isMulti={false}
                                                        isLoading={this.props.ratingRange.isLoading}
                                                        placeholder={this.props.t(`Common.Select`)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="field is-horizontal">
                                <div className="field-label" style={{ whiteSpace: "nowrap" }}><label className="label">
                                    {this.props.t('IRating.History.Date')} </label>
                                </div>
                                <div className="field-body">
                                    <div className="field-label">
                                        {this.props.t('IRating.History.From')}
                                    </div>
                                    <div className="field-body">
                                        <div className="field">
                                            <div className="control" style={{ position: 'relative' }}>
                                                <input 
                                                    className="input" 
                                                    value={this.state.filterDateFromText}
                                                    onChange={(e) => this.handleDateTextChange('filterDateFrom', e.target.value)}
                                                    onBlur={() => this.tryCommitDate('filterDateFrom')}
                                                    onKeyDown={(e) => this.handleDateTextKeyDown(e, 'filterDateFrom')}
                                                    onClick={() => this.setState({ showFromCalendar: !this.state.showFromCalendar, showToCalendar: false })}
                                                />
                                                {this.state.filterDateFromError && <p className="help is-danger">{this.state.filterDateFromError}</p>}
                                                {this.state.showFromCalendar && (
                                                    <div style={{ position: 'absolute', zIndex: 20, background: 'white', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                                                        <DayPicker
                                                            mode="single"
                                                            selected={this.state.filterDateFrom}
                                                            month={this.state.filterDateFrom || new Date()}

                                                            onSelect={day => this.setState({ filterDateFrom: day, filterDateFromText: formatDate(day), filterDateFromError: null, showFromCalendar: false })}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field-label">
                                        {this.props.t('IRating.History.To')}
                                    </div>
                                    <div className="field-body">
                                        <div className="field">
                                            <div className="control" style={{ position: 'relative' }}>
                                                <input 
                                                    className="input" 
                                                    value={this.state.filterDateToText}
                                                    onChange={(e) => this.handleDateTextChange('filterDateTo', e.target.value)}
                                                    onBlur={() => this.tryCommitDate('filterDateTo')}
                                                    onKeyDown={(e) => this.handleDateTextKeyDown(e, 'filterDateTo')}
                                                    onClick={() => this.setState({ showToCalendar: !this.state.showToCalendar, showFromCalendar: false })}
                                                />
                                                {this.state.filterDateToError && <p className="help is-danger">{this.state.filterDateToError}</p>}
                                                {this.state.showToCalendar && (
                                                    <div style={{ position: 'absolute', zIndex: 20, background: 'white', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                                                        <DayPicker
                                                            mode="single"
                                                            selected={this.state.filterDateTo}
                                                            month={this.state.filterDateTo || new Date()}
                                                            onSelect={day => this.setState({ filterDateTo: day, filterDateToText: formatDate(day), filterDateToError: null, showToCalendar: false })}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            { hasPermission(null, "UserCCB") &&
                                <FieldHorizontal label={this.props.t('IRating.History.Customer')}>
                                    <CustomSelect
                                        value={this.state.customerId}
                                        onChange={customerId => this.setState({ customerId })}
                                        options={this.props.domainsHistory.customers.map(x => { return { value: x.code, label: `${x.code} - ${x.name}` } })}
                                        isMulti={false}
                                        isLoading={this.props.domainsHistory.isLoading}
                                        placeholder={this.props.t(`Common.Select`)}
                                        isSearchable
                                        isClearable
                                    />
                                </FieldHorizontal>
                            }
                            <div className="field is-horizontal">
                                <div className="field-label">
                                </div>
                                <div className="field-body">
                                    <div className="field">
                                        <div className="control">
                                            <input className="button is-primary" type="submit" value={this.props.t('IRating.Report.Search.OK')} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default withTranslation("translation")(connect(
    state => state.appContext,
    dispatch => bindActionCreators(appContextActions, dispatch)
)(HistorySearchComponent));
